import React from "react";
import { Modal } from "react-bootstrap";
import OrganizationClassificationCreateForm from "./OrganizationClassificationCreateForm";

export default function OrganizationClassificationCreate({
  show,
  onHide,
  onSubmit,
  defaultValues
}) {
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>
            {defaultValues.uuid ? `Update Notifikasi` : "Tambah Notifikasi"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <OrganizationClassificationCreateForm
            onSubmit={onSubmit}
            defaultValues={defaultValues}
            onHide={onHide}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
